import React, { Component, Fragment } from "react";
import FocusTrap from "./FocusTrapReact";
class FocusManager extends Component {
  constructor(props) {
    super(props);
    this.id = `fm_${Math.floor(Math.random() * 9999)}`;
    this.onActivate = this.onActivate.bind(this);
    this.onDeactivate = this.onDeactivate.bind(this);
  }
  onActivate() {
  }
  onDeactivate() {
  }
  render() {
    const { children, focusTrapOptions, isMobile, jsdomMode, preventScroll, ...rest } = this.props;
    const options = {
      ...focusTrapOptions,
      onActivate: this.onActivate,
      onDeactivate: this.onDeactivate,
      clickOutsideDeactivates: true
    };
    if (isMobile) {
      return /* @__PURE__ */ React.createElement(Fragment, { ...rest }, children);
    } else if (jsdomMode) {
      return /* @__PURE__ */ React.createElement("div", { ...rest }, children);
    } else {
      return /* @__PURE__ */ React.createElement(FocusTrap, { focusTrapOptions: { ...options, preventScroll }, ...rest }, children);
    }
  }
}
FocusManager.defaultProps = {
  isMobile: false,
  focusTrapOptions: {
    clickOutsideDeactivates: true
  },
  jsdomMode: false
};
var FocusManager_default = FocusManager;
export {
  FocusManager_default as default
};
//# sourceMappingURL=FocusManager.js.map
